import { createReducer, on } from '@ngrx/store';
import { profileActions } from '../actions/profile.actions';
import { User } from '../models';

export interface ProfileState {
    profile: User | null;
}

export const initialState: ProfileState = {
    profile: null,
};

export const profileReducer = createReducer(
    initialState,
    on(profileActions.getProfileSuccess, (state, { payload }): ProfileState => ({
        ...state,
        profile: payload,
    })),
    // Clear
    on(profileActions.clear, (): ProfileState => ({ ...initialState })),
);
